/* istanbul ignore file */
import { focus, theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { TEXT_AREA_INPUT_CLASSNAME } from 'client-ribbons-design-system/components/elements/TextField/TextField';

const { fonts, responsiveText, spacing } = theme;

export const requiredLabel = css`
  background-color: var(--neutral-black-70);
  border-radius: ${pxToRem(6)};
  color: var(--neutral-white-base);
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  ${responsiveText.BODY.XS};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  line-height: 1.67;
  margin: 0;
  padding: 0 ${spacing.sm}px;
  position: absolute;
  right: ${pxToRem(16)};
  text-align: center;
  top: ${pxToRem(-10)};

  &[data-is-valid='true'] {
    background-color: var(--functional-green-base);
  }

  &[data-has-error='true'] {
    background-color: var(--functional-red-base);
  }
`;

export const entryFieldContainer = css`
  border-radius: ${pxToRem(10)};
  border: solid ${pxToRem(1)} var(--neutral-black-70);
  padding: ${pxToRem(16)};
  position: relative;
  transition: border-color 0.15s ease-in, background-color 0.15s ease-in;

  &:hover {
    border-color: var(--neutral-black-70);
  }

  &[data-has-error='true'] {
    border-color: var(--functional-red-base);
  }

  &[data-is-valid='true'] {
    border-color: var(--functional-green-base);
  }

  &[data-has-focus='true'] {
    ${focus}
  }

  .${TEXT_AREA_INPUT_CLASSNAME} {
    &.focus-visible:focus {
      box-shadow: none;
    }
  }
`;
